/**
 * i18n UDV — español por defecto.
 * Uso: import { t, setAppLanguage } from '../i18n'
 * Claves anidadas: t('fs.tooltip.openZip')
 * Override: ?lang=en|es  ·  persistencia: localStorage udv.lang
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import es from './locales/es.json'
import en from './locales/en.json'

export const LANG_STORAGE_KEY = 'udv.lang'
export const SUPPORTED_LANGS = ['es', 'en']

function detectLanguage() {
  try {
    const q = new URLSearchParams(window.location.search).get('lang')
    if (SUPPORTED_LANGS.includes(q)) return q
  } catch (_) {
    /* ignore */
  }
  try {
    const saved = localStorage.getItem(LANG_STORAGE_KEY)
    if (SUPPORTED_LANGS.includes(saved)) return saved
  } catch (_) {
    /* ignore */
  }
  return 'es'
}

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    lng: detectLanguage(),
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
    returnNull: false,
    react: { useSuspense: false },
  })
}

/** Traducción síncrona (válida en class components y utils). */
export function t(key, options) {
  return i18n.t(key, options)
}

export function getAppLanguage() {
  const lng = (i18n.language || 'es').split('-')[0]
  return SUPPORTED_LANGS.includes(lng) ? lng : 'es'
}

export function setAppLanguage(lng) {
  const next = SUPPORTED_LANGS.includes(lng) ? lng : 'es'
  try {
    localStorage.setItem(LANG_STORAGE_KEY, next)
  } catch (_) {
    /* ignore */
  }
  return i18n.changeLanguage(next)
}

/** Suscribirse a cambios de idioma (útil en class components). */
export function onAppLanguageChange(callback) {
  i18n.on('languageChanged', callback)
  return () => i18n.off('languageChanged', callback)
}

export default i18n
